/*
 * <cart-store-prompt> — VIS-721.
 *
 * Favorite-store banner in the cart (own card under the cart page summary,
 * inline under the drawer title), rendered by snippets/cart-store-prompt.liquid.
 * The favorite lives in localStorage `vo:favoriteStore`, owned by
 * store-favorites.js, so this element only reflects it: both states are
 * server-rendered hidden, and it reveals the warning while no favorite exists
 * or the "Il tuo centro ottico: NAME · Modifica" row once one is set. Every
 * anchor inside is marked as a store-selector trigger here (the warning's
 * anchor comes from a merchant-editable locale string), and the global
 * [data-store-selector-trigger] delegation in store-selector.js opens the
 * dialog.
 *
 * Re-runs on `store-favorite:changed` (same-tab picks) and on `storage`
 * (other-tab picks; store-favorites.js does not re-dispatch those). Cart morphs
 * skip this subtree (`data-skip-subtree-update`), and the cart page summary or
 * the filled drawer inserted fresh (empty → non-empty cart) reconnects the
 * element, so connectedCallback covers that path.
 */

import { getFavorite } from './store-favorites.js';

const STORAGE_KEY = 'vo:favoriteStore';

class CartStorePrompt extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('a').forEach((link) => link.setAttribute('data-store-selector-trigger', ''));
    window.addEventListener('store-favorite:changed', this.#reflect);
    window.addEventListener('storage', this.#onStorage);
    this.#reflect();
  }

  disconnectedCallback() {
    window.removeEventListener('store-favorite:changed', this.#reflect);
    window.removeEventListener('storage', this.#onStorage);
  }

  /** @param {StorageEvent} event */
  #onStorage = (event) => {
    if (event.key === STORAGE_KEY) this.#reflect();
  };

  #reflect = () => {
    const favorite = getFavorite();
    const hasFavorite = favorite != null;

    const empty = this.querySelector('[data-store-prompt-empty]');
    const selected = this.querySelector('[data-store-prompt-selected]');
    const name = this.querySelector('[data-store-prompt-name]');

    if (empty) empty.hidden = hasFavorite;
    if (selected) selected.hidden = !hasFavorite;
    if (name) name.textContent = hasFavorite ? favorite.name || '' : '';
  };
}

if (!customElements.get('cart-store-prompt')) {
  customElements.define('cart-store-prompt', CartStorePrompt);
}
